import React from 'react';
import classNames from 'classnames';
import { ButtonSize, Button, ButtonPriority } from 'wix-ui-tpa/cssVars';
import { classes } from './previous-button.st.css';
import { useFieldActions } from '../../../contexts/field-actions-context';
import { ForcedState, useForcedState } from '../../../contexts/forced-state-context';
const PreviousButton = _ref => {
  let {
    previousText,
    className
  } = _ref;
  const {
    actions
  } = useFieldActions();
  const forcedState = useForcedState();
  const hover = forcedState.includes(ForcedState.PREVIOUS_BUTTON_HOVER);
  return /*#__PURE__*/React.createElement(Button, {
    className: classNames(classes.previousButton, {
      [classes.previousButtonHover]: hover
    }, className),
    upgrade: true,
    priority: ButtonPriority.basicSecondary,
    size: ButtonSize.large,
    onClick: () => actions == null ? void 0 : actions.setPreviousStep()
  }, previousText);
};
export default PreviousButton;
//# sourceMappingURL=previous-button.js.map